<template>
	<Modal 
		:loading="loading" 
		:title="current == null ? 'NOVO MOTORISTA' : 'EDITAR MOTORISTA'"
		@close="close"
		@save="save"
	>
		<div class="row">
			<div class="col-xs-12" :class="client_atak ? 'col-lg-9' : 'col-lg-12'">
				<FormInput v-model="name" label="Nome" type="text" :required="true" tooltip="Informe o nome do motorista" ref="name" />
			</div>
			<div v-if="client_atak" class="col-xs-12 col-lg-3">
				<FormInput v-model="code" label="Código do motorista" type="text" :required="false" tooltip="Informe o código do motorista ('chave de fato' do registro do motorista no sistema integrado)" ref="code" />
			</div>
			<div class="col-xs-12 col-lg-6">
				<FormInputMasked v-model="document" label="CPF" type="text" :required="true" :disabled="id != '' ? true : false" mask="###.###.###-##" tooltip="Informe o CPF do motorista" ref="document" />
			</div>
            <div class="col-xs-12 col-lg-6">
				<FormInput v-model="nickname" label="Identificador" type="text" :required="false" tooltip="Informe o identificador personalizado para ser exibido no mapa de rastreio" ref="nickname" />
			</div>
			<div class="col-xs-12 col-lg-6">
				<FormInput v-model="email" label="E-mail" type="text" :required="false" tooltip="Informe o e-mail do motorista" ref="email" />
			</div>
			<div class="col-xs-12 col-lg-6">
				<FormInputMasked v-model="phone" label="Telefone" type="text" :required="false" mask="+## (##) #####-####" tooltip="Informe o telefone do motorista" ref="phone" />
			</div>
			<div v-if="Object.keys(options_my_vehicles).length > 0" class="col-xs-12 col-lg-12">
                <FormSelect v-model="license_plate" label="Veículo Fixo" :options="options_my_vehicles" tooltip="Selecione o veículo que o motorista dirige de forma recorrente" ref="license_plate" />
			</div>
		</div>
	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "../../components/Modal";
import FormInput from "../../components/FormInput";
import FormInputMasked from '../../components/FormInputMasked';
import FormSelect from '../../components/FormSelect.vue';

export default {
	name: "DriverForm",

	props: {
		current: {
			type: Object,
			require: false,
            default: null,
		},
		my_vehicles: {
			type: [Array, Object],
			require: false,
            default: null,
		},
	},

	components: {
        Modal,
        FormInput,
        FormInputMasked,
        FormSelect,
    },

	data: function() {
        if (this.current) {
            return {
                loading: false,
                id: this.current.id ? this.current.id : "",
                name: this.current.name ? this.current.name : "",
                document: this.current.document ? this.current.document : "",
                origin: this.current.origin ? this.current.origin : "",
                code: this.current.code ? this.current.code : "",
                nickname: this.current.nickname ? this.current.nickname : "",
                email: this.current.email ? this.current.email : "",
                phone: this.current.phone ? this.current.phone : "",
                license_plate: this.current.license_plate ? this.current.license_plate : "",
                client_atak: this.$api.user.company_client_atak,
            }
        } else {
            return {
                loading: false,
                id: "",
                name: "",
                document: "",
                origin: "",
                code: "",
                nickname: "",
                email: "",
                phone: "",
                license_plate: "",
                client_atak: this.$api.user.company_client_atak,
            }
        }
	},

    computed: {
        options_my_vehicles: function() {
			let r = {};
			this.my_vehicles.map(v => {
				r[v.license_plate] = v.license_plate.toUpperCase() + " - " + v.brand.toUpperCase();
			});
			return r;
		},
    },

	methods: {
        /**
         * Valida os campos
         * @returns array | boolean com o resultado da validação
         */
        validate: function() {
            // Inicia o objeto de retorno
            let data = {
                id: "",
                name: "",
                document: "",                
                origin: "",
                code: "",
                nickname: "",
                email: "",
                phone: "",
                license_plate: "",
            }

            let error = false;

            if (this.id != "") {
                data.id = this.id;
            }

            if (this.name != "") {
                data.name = this.name.toUpperCase();
            } else {
                this.$notification.error("'NOME' deve ser preenchido.");
                this.$refs.name.validate();
                error = true;
            }
            
            if (this.origin) {
                data.origin = this.origin;
            } else {
                data.origin = "b2b";
            }
            
            data.code = this.code;

            if (this.document != "") {
                data.document = this.document;
            } else {
                this.$notification.error("'CPF' deve ser preenchido.");
                this.$refs.document.validate();
                error = true;
            }
            
            data.nickname = this.nickname;
            data.email = this.email;
            data.phone = this.phone;
            data.license_plate = this.license_plate;
            
            // Verifica se houve error
            if (error) {
                return false;
            } else {
                return data;
            }
        },

		/**
         * Envia para API e salva as informações no BD e XML
         */ 
        save: async function() {
            // Valida os dados
			let data = this.validate();

            // Verifica o resultado
            if (data) {
                // Inicia a requisição
                let result = null;
                let form = {};
                form.data= data;

                this.loading = true;
                try {
                    result = await Api.post("driver/save-driver", form);
                } catch(ex) {
                    console.log(ex);
                    this.loading = false;
                    this.$notification.error("Não foi possível salvar as informações do motorista.");
                    return;
                }
                this.loading = false;

                if (result) {
                    if (result.error) {
                        if (result.data == "unauthorized") {
                            this.$notification.error("Desculpe, sua sessão expirou.");
                            setTimeout(() => {
                                Api.logout();
                                return;
                            }, 2000);
                        } else {
                            this.$notification.error(result.data);
                            return;
                        }
                    } else {
                        this.$notification.success("Motorista salvo com sucesso.");
                        this.close();
                        return;
                    }
                } else {
                    this.$notification.error("Não foi possível salvar as informações do motorista.");
                    return;
                }
            }
		},

		/**
		 * Fecha o modal
		 **/ 
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped></style>